import $ from 'jquery';

// Forms - Submit button loading
export default function loadingButton(form) {
  var loadingButtonSubmit = $(form).find(".btn-loading");

  loadingButtonSubmit.attr("disabled", true);
  loadingButtonSubmit.html("<span class='btn-loading-icon'></span>" + loadingButtonSubmit.attr("data-loading-text"));

  setTimeout(function () {
    loadingButtonSubmit.removeAttr("disabled").html(loadingButtonSubmit.val());
  }, 1500);
}
